import './kopper/style';
import FormStructure from './kopper/form_structure';

export default FormStructure;